import { useEffect, useState } from 'react';

/**
 * useDebounce - returns a debounced version of `value` that only updates
 * after `delay` ms have elapsed since the last change. Used to avoid
 * firing an API call on every keystroke in search inputs.
 */
export function useDebounce(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}

export default useDebounce;
